import ApiClient from './ApiClient';

export default class DomainsApi extends ApiClient {
  /**
   * Список доменов
   * @returns {*}
   */
  fetchDomains () {
    return this.get(`${this.prefix}domains`);
  }
}



// WEBPACK FOOTER //
// ./src/api/DomainsApi.js